import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Report
function creatReport(params: any) {
    const baseUrl = `/report/createReport`;
    return api.create(`${baseUrl}`, params);
}
// update Report
function updateReport(params: any) {
    const baseUrl = '/report/updateReport';
    return api.update(`${baseUrl}`, params);
}

// get all Reports
function getAllReport(params: any) {
    const baseUrl = '/dashboard/getPatientList';
    return api.create(`${baseUrl}`, params);
}

// get all Service Reports
function getAllServiceReport(params: any) {
    const baseUrl = '/Services/getServiceListPat';
    return api.create(`${baseUrl}`, params);
}

// get all Sales Reports
function getAllSalesReport(params: any) {
    const baseUrl = '/revDataRep/getSaleData';
    return api.create(`${baseUrl}`, params);
}

// get Report
function getReport(params: any) {
    const baseUrl = '/report/getReportDtl';
    return api.create(`${baseUrl}`, params);
}

function getValidateReport(params: any) {
    const baseUrl = '/report/validateReport';
    return api.create(`${baseUrl}`, params);
}
// get Observation Report
function getObservationReport(params: any) {
    const baseUrl = '/observRep/getObservationDtl';
    return api.create(`${baseUrl}`, params);
}

export {
    creatReport,
    updateReport,
    getAllReport,
    getReport,
    getValidateReport,
    getAllServiceReport,
    getObservationReport,
    getAllSalesReport,
};
